import { createContext, ReactNode, useContext, useState } from 'react';

export interface Result {
  isRearrangeModalVisible: boolean;
  setIsRearrangeModalVisible: (any) => void;
}

export const ProjectSpacesRearrangeModalContext = createContext<Result | null>(
  null,
);

// TODO: move away from context based approach and use routing to manage state of whether the modal is open or not
export const useProjectSpacesRearrangeModalContext = (): Result => {
  const context = useContext(ProjectSpacesRearrangeModalContext);

  if (!context) {
    throw new Error(
      'This must be used within a <SpaceContainer> component or wrap it with ProjectSpacesRearrangeModalContext.Provider.',
    );
  }

  return context;
};

export const ProjectSpacesRearrangeModalContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isRearrangeModalVisible, setIsRearrangeModalVisible] = useState(false);

  return (
    <ProjectSpacesRearrangeModalContext.Provider
      value={{ isRearrangeModalVisible, setIsRearrangeModalVisible }}
    >
      {children}
    </ProjectSpacesRearrangeModalContext.Provider>
  );
};
